import React from "react";
import styled from "styled-components";
import { RowContainer } from "../containers/styledComponents";
import { IconContainer, Icon } from "../visuals/styledComponents";
import { CompassParagraph } from "../common/styledComponents";
import { ToastContextType } from "../../types/toastTypes";

const LoginButton = styled.button`
  display: flex;
  flex-direction: row;
  height: 55px;
  width: 100%;
  align-items: center;
  justify-content: center;
  border: 1px solid #eeeeee;
  border-radius: 12px;
  background-color: white;

  &:hover {
    background-color: #eeeeee;
  }
`;

const comingSoonMessage =
  "Coming soon! Please login with your username and password in the meantime.";

const LoginMethod = ({
  icon,
  message,
  size = 80,
  addToast,
}: LoginMethodProps): JSX.Element => {
  return (
    <RowContainer>
      <LoginButton onClick={(): void => addToast(comingSoonMessage, "info")}>
        <IconContainer size={size}>
          <Icon src={icon} />
        </IconContainer>
        <CompassParagraph>{message}</CompassParagraph>
      </LoginButton>
    </RowContainer>
  );
};

type LoginMethodProps = {
  icon: string;
  message: string;
  addToast: ToastContextType["addToast"];
  size?: number;
};

export default LoginMethod;
